import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ElectionDayContext = createContext(null);

export function ElectionDayProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/election-day");
      setState(data);
    } catch { /* yoksay */ }
  }, []);

  useEffect(() => {
    if (!user) { setState(null); return; }
    refresh();
    const id = setInterval(refresh, 30000);
    return () => clearInterval(id);
  }, [user, refresh]);

  return (
    <ElectionDayContext.Provider value={{ ed: state, refreshEd: refresh, setEd: setState }}>
      {children}
    </ElectionDayContext.Provider>
  );
}

export const useElectionDay = () => useContext(ElectionDayContext) || { ed: null, refreshEd: () => {} };
